import storage from "./storage/storage";
import IndexedDbMigrationFromRedux from "./storage/indexedDbMigrationFromRedux";
import { IndexedDbStorage } from "./storage/indexedDbStorage";

interface IForgetApi {
    forget(): void;
}

/**
 * @deprecated Legacy logout-storage cleanup path kept only to share behavior
 * between deprecated `doLogout` URL handling and the old LoginView constructor flow.
 * Prefer explicit modern logout flows instead.
 */
export async function clearLegacyLogoutStorage(api: IForgetApi, awaitIndexedDbClear = false): Promise<void> {
    if (IndexedDbMigrationFromRedux.isIndexedDbInUse) {
        const clearPromise = IndexedDbStorage.clear();
        if (awaitIndexedDbClear) {
            await clearPromise;
        } else {
            void clearPromise;
        }
    } else {
        storage.clear();
    }

    api.forget();
}
